import React, { useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Spin } from "antd";
import styled from "styled-components";

import { useApi, ApiNames } from "../../hooks/api";
import { Routes } from "../../constant/routes";
import ErrorMessage from "../../component/customComponent/customMessages/ErrorMessage";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;

const PatientRedirect = () => {
  const { patientId } = useParams();
  const history = useHistory();
  const [getPatientJourney, journeyResult, , error] = useApi(ApiNames.GetPatientJourney);
  const hasFetched = useRef(false);
  const lastPatientId = useRef(null);

  useEffect(() => {
    // Reset hasFetched if patientId changes
    if (lastPatientId.current !== patientId) {
      hasFetched.current = false;
      lastPatientId.current = patientId;
    }

    if (patientId && !hasFetched.current && !journeyResult && !error) {
      hasFetched.current = true;
      getPatientJourney(patientId);
    }
  }, [patientId]);

  useEffect(() => {
    if (journeyResult?.journey?.id) {
      const journeyId = journeyResult.journey.id;
      const fullPath = Routes.PATIENT_JOURNEY_PATH({ patientId, journeyId });
      history.replace(fullPath);
    }
  }, [journeyResult, patientId, history]);

  useEffect(() => {
    if (error) {
      ErrorMessage("Could not retrieve patient journey. Redirecting to dashboard.");
      setTimeout(() => {
        history.replace(Routes.ROOT);
      }, 2000);
    }
  }, [error, history]);

  if (error) {
    return (
      <Container>
        <div>Error loading patient journey. Redirecting...</div>
      </Container>
    );
  }

  return (
    <Container>
      <Spin size="large" />
    </Container>
  );
};

export default PatientRedirect;
